import { Injectable, Injector } from '@angular/core';
import { EntityApiClient } from 'mm-web-core/http';
import { RoleModel } from '../definition/role.model';

@Injectable({
  providedIn: 'root'
})
export class RoleApiService extends EntityApiClient<RoleModel, any> {

  constructor(injector: Injector) {
    super(injector, "role")

  }

  getPermissions(id: string) {
    return this.httpClient.get<string[]>(`api/role/${id}/permissions`)
  }
}
